import React, { useEffect, useState } from "react";
import HeaderSelector from "../headerSelector/HeaderSelector";
import FooterSelector from "../footerSelector/FooterSelector";
import Stepper from "../stepper/Stepper";
import TemplateEditor from "../templateEditor/TemplateEditor";
import { useTranslator } from "context/translator";

const EmailTemplateWizard = ({
  template,
  headerTemplates,
  footerTemplates,
  onSave,
}) => {
  const { translate } = useTranslator();
  const steps = [
    translate("subject"),
    translate("header"),
    translate("footer"),
    translate("body"),
  ];
  const [step, setStep] = useState(0);

  const [localTemplate, setLocalTemplate] = useState(template);

  useEffect(() => {
    setLocalTemplate(template);
    setStep(0);
  }, [template]);

  const handleHeaderSelect = (header) => {
    setLocalTemplate((prev) => ({
      ...prev,
      headerTemplateId: header?._id,
    }));
  };

  const handleFooterSelect = (footer) => {
    setLocalTemplate((prev) => ({
      ...prev,
      footerTemplateId: footer?._id,
    }));
  };

  const canContinue = () => {
    if (step === 0) return !!localTemplate?.subject;
    if (step === 1) return !!localTemplate?.headerTemplateId;
    if (step === 2) return !!localTemplate?.footerTemplateId;

    return true;
  };

  return (
    <div className="flex flex-col h-full">
      <Stepper steps={steps} currentStep={step} />

      <div className="flex-1 mt-6">
        {step === 0 && (
          <>
            <p className="dark:text-white text-black mb-2">
              {translate("subject")}
            </p>
            <input
              value={localTemplate?.subject}
              onChange={(e) =>
                setLocalTemplate((prev) => ({
                  ...prev,
                  subject: e.target.value,
                }))
              }
              placeholder={translate("subject")}
              className="p-2 mb-3 border rounded-lg dark:bg-gray-800 dark:text-white"
            />
          </>
        )}
        {step === 1 && (
          <HeaderSelector
            templates={headerTemplates}
            selectedId={localTemplate?.headerTemplateId}
            onSelect={handleHeaderSelect}
          />
        )}

        {step === 2 && (
          <FooterSelector
            templates={footerTemplates}
            selectedId={localTemplate?.footerTemplateId}
            onSelect={handleFooterSelect}
          />
        )}

        {step === 3 && (
          <TemplateEditor
            template={localTemplate}
            setTemplate={setLocalTemplate}
            type={"email"}
            onSave={onSave}
            headerTemplates={headerTemplates}
            footerTemplates={footerTemplates}
          />
        )}
      </div>

      <div className="flex justify-between mt-6">
        <button
          onClick={() => setStep((prev) => prev - 1)}
          disabled={step === 0}
          className="px-4 py-2 rounded bg-gray-300 disabled:opacity-50"
        >
          Back
        </button>

        {step < 3 ? (
          <button
            onClick={() => setStep((prev) => prev + 1)}
            disabled={!canContinue()}
            className="px-4 py-2 rounded bg-blue-600 text-white disabled:opacity-50"
          >
            {translate("continue")}
          </button>
        ) : (
          <button
            onClick={() => onSave(localTemplate)}
            className="px-4 py-2 rounded bg-green-600 text-white"
          >
            {translate("save")}
          </button>
        )}
      </div>
    </div>
  );
};

export default EmailTemplateWizard;
